import { Capacitor } from '@capacitor/core';
import { currentUser, isLoggedIn } from './authentication';
import { initCleverTap } from './clevertapService';

export const onUserLogin = () => {
  if (currentUser()?.id) {
    if (Capacitor.isNativePlatform()) {
      window.CleverTap.onUserLogin({
        Identity: String(currentUser().id),
      });
    } else {
      initCleverTap().then((clevertap) => {
        if (clevertap) {
          clevertap.onUserLogin.push({
            Site: {
              Identity: String(currentUser().id),
            },
          });
        }
      });
    }
    console.warn('CleverTap user ID set:', currentUser().id);
  }
};

export const pushEvent = (eventName: string) => {
  if (Capacitor.isNativePlatform()) {
    window.CleverTap.recordEventWithName(eventName);
  } else {
    if (isLoggedIn()) {
      initCleverTap().then((clevertap) => {
        if (clevertap) {
          clevertap.event.push(eventName);
        }
      });
    }
  }
  console.warn('CleverTap event pushed:', eventName);
};

export const pushEventWithProperties = (eventName: string, properties: Record<string, string>) => {
  if (Capacitor.isNativePlatform()) {
    window.CleverTap.recordEventWithNameAndProps(eventName, properties);
  } else {
    if (isLoggedIn()) {
      initCleverTap().then((clevertap) => {
        if (clevertap) {
          clevertap.event.push(eventName, properties);
        }
      });
    }
  }
  console.warn('CleverTap event pushed:', eventName);
};

export const initPushNotifications = () => {
  if (!Capacitor.isNativePlatform()) {
    if (isLoggedIn()) {
      initCleverTap().then((clevertap) => {
        if (clevertap) {
          clevertap.notifications.push({
            //skipDialog: true,
            titleText: 'Vuoi consentire le notifiche da questo sito?',
            bodyText: 'Promettiamo di inviarti solo contenuti rilevanti e aggiornamenti sulle partite e tornei',
            okButtonText: 'Ci sto!',
            rejectButtonText: 'No grazie',
            // okButtonColor: '#F28046',
            askAgainTimeInSeconds: 5,
            serviceWorkerPath: '/service-worker.js',
          });
        }
      });
      console.warn('CleverTap push notifications initialized');
    }
  }
};
